import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../images/services-usa/2d-game/build_game.webp";

function Streamlinecloud() {
  return (
    <section
      className="streamline_cloud blockchain_future"
      style={{
        backgroundImage: `url(${BgImg})`,
      }}
    >
      <Container>
        <Row>
          <Col xs={12} md={7} lg={6} xl={5} xxl={5}>
            <h2>
              Build Your Next <span>Hit 2D Game</span>
            </h2>
            <p>
              Design interactive worlds with performance-driven gameplay with
              our high-caliber 2D game development company.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Start Building Now
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Streamlinecloud;
